// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryPicker_wrapper__wfBYQ","label":"CategoryPicker_label__NXL5T","createNewCategoryBtn":"CategoryPicker_createNewCategoryBtn__xbto-"};